var _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hostel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78.001,
    viewBox: "0 0 78 78.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279",
    transform: "translate(53.07 8.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    d: "M362.538,68.026a15.785,15.785,0,0,1-.1-5.327,5.191,5.191,0,0,0-1.273-4.371,4.732,4.732,0,0,0-3.364-1.4,4.528,4.528,0,0,0-4.355,3.223,5.068,5.068,0,0,0-3.608,1.485,5.187,5.187,0,0,0-.975,5.877,5.4,5.4,0,0,0,1.067,1.514,5.6,5.6,0,0,0,3.211,1.545,4.748,4.748,0,0,0,.676.045,16.182,16.182,0,0,0,3.142-.462,15.748,15.748,0,0,1,2.834-.434,1.582,1.582,0,0,1,.594.078l.035.014a1.523,1.523,0,0,0,2.115-1.784Z",
    transform: "translate(-348.356 -56.925)",
    fill: "#ed0000"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    "data-name": "Path 4252",
    d: "M75.649,10.06l-7.7-7.7A7.936,7.936,0,0,0,62.306,0a7.5,7.5,0,0,0-5.339,2.19L43.443,15.564A7.717,7.717,0,0,0,42.4,25.017a18.964,18.964,0,0,0-2.457,1.912l-2.571-2.571a8.062,8.062,0,0,0-5.758-2.324,9.849,9.849,0,0,0-6.882,2.938l-7.213,7.215c-3.653,3.654-3.929,9.324-.613,12.64l1.95,1.95a4.175,4.175,0,0,1,1.27,2.207,1.474,1.474,0,0,1-.06.844,8.314,8.314,0,0,1-1.735-.856,6.88,6.88,0,0,0-3.251-1.242A2.6,2.6,0,0,0,13.2,48.5c-1.646,1.646-.588,3.9.185,5.548a7.318,7.318,0,0,1,.766,2.1h-.021a5.316,5.316,0,0,1-1.511-.518,7.327,7.327,0,0,0-2.891-.81A3.371,3.371,0,0,0,7.3,55.829c-1.744,1.744-.8,3.836-.234,5.086.542,1.2.55,1.441.4,1.643-.452.59-1.645.088-2.2-.109a6.977,6.977,0,0,0-2.34-.535c-.9,0-2.921.066-2.807,2.149L0,75.409A1.523,1.523,0,0,0,1.239,76.92l5.494,1.053a1.523,1.523,0,0,0,1.37-.425L28.752,56.674l1.111,1.112a8.062,8.062,0,0,0,5.758,2.324h0A9.847,9.847,0,0,0,42.5,57.172l7.214-7.215c3.654-3.654,3.929-9.325.613-12.641l-2.7-2.7,2.019-2.019,1.66,1.661a7.937,7.937,0,0,0,5.642,2.358,7.5,7.5,0,0,0,5.339-2.19L75.811,21.049A7.783,7.783,0,0,0,75.649,10.06Zm-31.239,17.3,3.082,3.082-2.019,2.019L42.1,29.087A15.117,15.117,0,0,1,44.409,27.357ZM48.174,39.47c2.128,2.128,1.853,5.866-.613,8.332l-7.214,7.215a6.781,6.781,0,0,1-4.726,2.045h0a5.038,5.038,0,0,1-3.6-1.431l-2.195-2.195a1.524,1.524,0,0,0-1.077-.446h0a1.523,1.523,0,0,0-1.079.452L6.508,74.828l-3.446-.661.092-9.182A22.337,22.337,0,0,0,6.81,65.9a3.852,3.852,0,0,0,2.807-1.184c1.728-1.729.789-3.809.227-5.051-.55-1.217-.552-1.462-.388-1.677.245-.32,1.351.176,1.941.435a6.9,6.9,0,0,0,2.736.775,3.047,3.047,0,0,0,2.2-.906c1.642-1.642.585-3.893-.186-5.537a10.752,10.752,0,0,1-.749-1.887,12.773,12.773,0,0,1,1.4.741,7.1,7.1,0,0,0,3.378,1.282h0a2.745,2.745,0,0,0,1.982-.812,4.046,4.046,0,0,0,.972-3.6,7.22,7.22,0,0,0-2.12-3.858l-1.95-1.95c-2.128-2.128-1.853-5.866.613-8.332l7.214-7.215a6.782,6.782,0,0,1,4.727-2.045,5.036,5.036,0,0,1,3.6,1.432l2.6,2.6a17.467,17.467,0,0,0-2.538,3.725,4.292,4.292,0,0,0-2.177-.607,3.9,3.9,0,0,0-2.784,1.138l-2.3,2.3a4.135,4.135,0,0,0,.145,5.834l5.02,5.021a4.352,4.352,0,0,0,3.05,1.283,3.9,3.9,0,0,0,2.784-1.138l2.3-2.3a4.135,4.135,0,0,0-.145-5.834l-3.508-3.508a12.444,12.444,0,0,1,2.313-3.753Zm-13.662-.694c.405,1.062.957,1.186,1.4,1.218a1.75,1.75,0,0,0,.849-.188,1.266,1.266,0,0,0,.6-.771l1.653,1.654a1.1,1.1,0,0,1,.145,1.526l-2.3,2.3a.873.873,0,0,1-.629.245,1.287,1.287,0,0,1-.9-.39l-5.02-5.021a1.1,1.1,0,0,1-.145-1.526l2.3-2.3a.874.874,0,0,1,.629-.245,1.287,1.287,0,0,1,.9.39s.3.326.3.337A6.5,6.5,0,0,0,34.512,38.776Zm39.15-19.888L60.139,32.262a4.474,4.474,0,0,1-3.191,1.3A4.911,4.911,0,0,1,53.461,32.1l-5.953-5.954a4.936,4.936,0,0,1,3.21.373,1.638,1.638,0,0,0,2.056-.678,1.309,1.309,0,0,0-.358-1.777,4.447,4.447,0,0,0-.75-.462,8.882,8.882,0,0,0-6.532.034,4.676,4.676,0,0,1,.459-5.912L59.115,4.351a4.473,4.473,0,0,1,3.191-1.3,4.91,4.91,0,0,1,3.487,1.465l7.7,7.7A4.732,4.732,0,0,1,73.662,18.889Z",
    transform: "translate(-0.003 0)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    transform: "translate(32.881 14.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    "data-name": "Path 4253",
    d: "M218.8,93.851a1.513,1.513,0,0,0-.763-.878s0,0,0,0a1.52,1.52,0,0,0-2.043.682,1.524,1.524,0,0,0,.682,2.043,1.524,1.524,0,0,0,2.125-1.846Z",
    transform: "translate(-215.836 -92.81)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285",
    transform: "translate(15.772 13.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    "data-name": "Path 4254",
    d: "M117.688,91.957a1.531,1.531,0,0,0-1.461-1.1,1.514,1.514,0,0,0-.428.061,23.891,23.891,0,0,0-8.288,4.791,36.882,36.882,0,0,0-3.586,3.391l0,0a1.523,1.523,0,1,0,2.272,2.031l.049-.053a35.094,35.094,0,0,1,3.6-3.344,21.471,21.471,0,0,1,6.813-3.9,1.522,1.522,0,0,0,1.036-1.889Z",
    transform: "translate(-103.533 -90.86)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287",
    transform: "translate(37.222 56.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    "data-name": "Path 4255",
    d: "M258.413,374.433a1.524,1.524,0,0,0-1.519-1.412,1.522,1.522,0,0,0-1.153.527l-.047.055a35.184,35.184,0,0,1-3.544,3.4,21.466,21.466,0,0,1-6.746,4.01,1.523,1.523,0,1,0,.9,2.91,19.244,19.244,0,0,0,4.5-2.154,32.388,32.388,0,0,0,3.7-2.774,36.9,36.9,0,0,0,3.53-3.454l0,0A1.514,1.514,0,0,0,258.413,374.433Z",
    transform: "translate(-244.331 -373.021)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    transform: "translate(31.278 64.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    d: "M207.495,423.889h0a1.5,1.5,0,0,0-.655-.149,1.529,1.529,0,0,0-1.374.867,1.524,1.524,0,0,0,.714,2.031,0,0,0,0,1,0,0,1.512,1.512,0,0,0,.657.149,1.524,1.524,0,0,0,.658-2.9Z",
    transform: "translate(-205.313 -423.74)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostel);
export default __webpack_public_path__ + "static/media/hostel.a407a7e2de3307e16dc763c3793b4a6c.svg";
export { ForwardRef as ReactComponent };